/**
 * Carga
 * @author Simpli CLI generator
 */
import CargaCsvSimplificadoSchema from '@/schema/CargaCsvSimplificado.schema'
import Carga from '@/model/resource/Carga'

export default class CargaCsvSimplificado extends Carga {

  get $schema() {
    return CargaCsvSimplificadoSchema(this)
  }

}
